import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{staticStyle:{"height":"100vh !important"},attrs:{"app":"","data-iframe-height":""}},[_c(VMain,{style:(_vm.$vuetify.breakpoint.width >= 960 ? 'display: grid; align-items: center; background-color:' + _vm.appStyle.backgroundColor : _vm.appStyle)},[_c('div',{attrs:{"id":"version","version":_vm.version}}),_c('Item')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }